/**
 * dashboardUtils — helper e costanti condivise della Dashboard.
 * ★ Fase 59.P2 — estratto da DashboardPage.jsx (split componenti oversize).
 */
import i18n from '../../i18n';

export const CHART_TICK_STYLE = { fontSize: 10, fill: '#6b7280' };
export const ACCENT_TILE_STYLE = { backgroundColor: 'hsl(var(--accent))' };

// Stable inline literals (avoid re-creating objects/arrays on every render).
export const BAR_RADIUS = [4, 4, 0, 0];

export const fmtEur = (n) => {
  const num = Number(n) || 0;
  if (num === 0) return '€ 0';
  return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(num);
};

export const todayIso = () => new Date().toISOString().slice(0, 10);
export const daysAgoIso = (n) => {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d.toISOString().slice(0, 10);
};

export const QUICK_RANGES = [
  { key: '7d', get label() { return i18n.t('dashboard.range7d', 'Ultimi 7 giorni'); }, days: 7, granularity: 'daily' },
  { key: '30d', get label() { return i18n.t('dashboard.range30d', 'Ultimi 30 giorni'); }, days: 30, granularity: 'daily' },
  { key: '90d', get label() { return i18n.t('dashboard.range90d', 'Ultimi 90 giorni'); }, days: 90, granularity: 'weekly' },
  { key: '12m', get label() { return i18n.t('dashboard.range12m', 'Ultimi 12 mesi'); }, days: 365, granularity: 'monthly' },
];
